import { config } from "@/config";

export const URLS = {
  // dashboard
  DASHOARD: `${config.API_URL_V4}/dashboard/`,
  READ_DASHBOARD_ARTICLES: `${config.API_URL_V4}/dashboard/read/`,

  // mentions
  MENTIONS: `${config.API_URL}/mentions/`,
  MENTIONS_RESET: `/dashboard/reports/:uuid/reset-mentions/`,

  // api-mentions
  REPORT_MENTIONS: `${config.API_URL}/mentions-list/`,

  // api-set-mention-sentiment
  MENTION_SET_SENTIMENT: `${config.API_URL}/mentions/set-sentiment/`,

  MENTION_AMEND: `${config.API_URL}/mentions/:public_id/`,

  // api-mention-set-irrelevant
  MENTION_MARK_IRRELEVANT: `${config.API_URL}/set_mentions_irrelevant/`,

  // api-mention-set-irrelevant
  MENTION_MARK_RELEVANT: `${config.API_URL}/set_mentions_relevant/`,

  // favorite-api
  FAVORITE: "/customer_api/favorite/",

  // api-timezones
  TIMEZONES: `${config.API_URL}/timezones/`,

  // api-preview-results
  API_PREVIEW_RESULTS: `${config.API_URL}/search/preview/`,

  // api-search
  SEARCHES_LIST: `${config.API_URL}/searches/`,
  SEARCHES_LIST_ONGOING: `${config.API_URL}/searches/ongoing/`,
  SEARCHES_DETAIL: `${config.API_URL}/searches/:uuid/`,
  SEARCHES_FIND_FEED_INDEX: `${config.API_URL_V4}/mention-cards/:mention_uuid/index/`,
  SEARCHES_DETAIL_MENTIONS: `${config.API_URL}/searches/:uuid/mentions/`,
  SEARCHES_DETAIL_MENTIONS_V4: `${config.API_URL_V4}/mention-cards/?search_id=:uuid&full_count=false`,
  MENTION_CARDS_HIDE_IRRELEVANT: `${config.API_URL_V4}/mention-cards/:uuid/hide-irrelevant/`,
  SEARCHES_DETAIL_MENTIONS_V4_TAG: `${config.API_URL_V4}/mention-cards/?slug=:slug&full_count=false`,
  SEARCHES_LATEST_MENTIONS: `${config.API_URL}/searches/latest-mentions/`,
  SEARCHES_INSIGHTS: `${config.API_URL}/searches/:uuid/insights/`,
  SEARCHES_FILTER_OPTIONS: `${config.API_URL_V2}/searches/:uuid/filter_options/`,
  SEARCHES_HIDDEN_MENTIONS: `${config.API_URL}/searches/:uuid/mentions/hidden/`,
  SEARCHES_UNREAD_NOTIFICATION_SEEN: `${config.API_URL_V2}/searches/:uuid/seen/`,
  SEARCHES_TEMPLATES: `${config.API_URL_V2}/searches/templates/`,
  SEARCHES_TOPWIDGETS: `${config.API_URL}/searches/:uuid/mentions/topwidgets/`,

  REPORT_LIST: `${config.API_URL}/reports/`,
  REPORT: `${config.API_URL}/reports/:uuid/`,

  // archive search
  SEARCH: `${config.API_URL}/search/`,
  SAVE_STATIC_SEARCH: `${config.API_URL}/searches/`,

  // track-api
  TRACK: `/customer_api/track/`,

  // Action: Get full transcript
  FULL_TRANSCRIPT: `${config.DASHBOARD_URL}/transcripts/:pk`,

  // dashboard_episode_request_transcribe
  REQUEST_TRANSCRIBE: `${config.DASHBOARD_URL}/mentions/:episode_pk/request_transcribe`,

  // api-tags
  TAGS: `${config.API_URL}/tags/`,
  TAGS_FILTER_OPTIONS: `${config.API_URL_V2}/tags/:tag/filter_options/`,

  // api-organizations
  ORGANIZATIONS: `${config.API_URL}/organizations/`,
  ORGANIZATIONS_DETAIL_V4: `${config.API_URL_V4}/organizations/:uuid/`,
  ORGANIZATION_CAPABILITIES: `${config.API_URL}/organizations/:uuid/capabilities/`,
  ORGANIZATION_USERS: `${config.API_URL_V2}/organizations/:uuid/users/`,
  ORGANIZATION_USER: `${config.API_URL_V2}/organizations/:uuid/users/:user_id/`, // You can pass /me to get the authenticated user
  ORGANIZATION_LIST: `${config.API_URL}/organizations/all/`,
  ORGANIZATION_USER_SEARCH_SUBSCRIPTIONS: `${config.API_URL_V2}/organizations/:uuid/users/:user_id/alert-subscriptions/`,
  ORGANIZATION_USER_SEARCH_SUBSCRIPTIONS_CREATE: `${config.API_URL_V2}/organizations/:organization_uuid/users/:user_id/alert-subscriptions/add/`,
  ORGANIZATION_USER_SEARCH_SUBSCRIPTIONS_AVAILABLE_LIST: `${config.API_URL_V2}/organizations/:organization_uuid/users/:user_id/mailtypes/`,
  ORGANIZATION_USER_SEARCH_SUBSCRIPTIONS_EDIT: `${config.API_URL_V2}/organizations/:uuid/users/:user_id/alert-subscriptions/:sub_id/`,
  ORGANIZATION_USER_REPORT_SUBSCRIPTIONS: `${config.API_URL_V2}/organizations/:uuid/users/:user_id/report-subscriptions/`,
  ORGANIZATION_USER_REPORT_SUBSCRIPTIONS_DELETE: `${config.API_URL_V2}/organizations/:uuid/users/:user_id/report-subscriptions/:sub_id/delete/`,
  ORGANIZATION_USER_REPORT_SUBSCRIPTIONS_ADD: `${config.API_URL_V2}/organizations/:uuid/users/:user_id/report-subscriptions/add/`,
  ORGANIZATION_USAGE: `${config.API_URL}/organizations/current/usage/`,

  // api-features
  FEATURES: `${config.API_URL}/features/`,

  // api-async-export
  ASYNC_EXPORT: `${config.API_URL}/exports/`,

  // api-task-create
  TASK_NEW: `${config.API_URL}/tasks/:type/`,

  // api-task-result
  TASK_STATUS: `${config.API_URL}/tasks/:type/:id/`,

  // api-public-mention
  PUBLIC_MENTION: `${config.API_URL_V2}/mention/:public_id/`,

  // user
  USER: `${config.API_URL}/users/:uuid/`,
  USER_ACTIVATE: `${config.API_URL_V3}/users/me/activate/`,
  USER_SET_PASSWORD: `${config.API_URL_V3}/users/me/set-password/`,

  // reports-detail-by-token
  PUBLIC_REPORT_BY_TOKEN: `${config.API_URL}/reports/token/:token/`,
  PUBLIC_SEARCH: `${config.API_URL}/public-search/`,

  // internal-api-v4
  INTERNAL_CHANNEL_LIST: `${config.API_URL_V4}/channels/`,
  INTERNAL_CHANNEL_DETAIL: `${config.API_URL_V4}/channels/:id/`,
  INTERNAL_EPISODE_LIST: `${config.API_URL_V4}/episodes/`,
  INTERNAL_EPISODE_DETAIL: `${config.API_URL_V4}/episodes/:id/`,

  // Entities
  ENTITY_LIST: `${config.API_URL_V4}/entities/`,

  // Search suggestions
  SEARCH_SUGGESTIONS: `${config.API_URL_V4}/search-suggestions/`,

  // Payments and subscriptions
  PLAN_LIST: `${config.API_URL_V4}/plans/`,
  GROWTH_PLAN_LIST: `${config.API_URL_V4}/plans/growth/`,
  CREATE_CHECKOUT_SESSION: `${config.API_URL_V4}/stripe/create-checkout-session/`,

  // auth
  LOGIN: `${config.API_URL_V3}/users/login/`,
  // LOGOUT: `${config.API_URL_V2}/logout/`,

  // Translations
  TRANSLATE: `${config.API_URL_V4}/translations/`,

  SIGNUP: `${config.API_URL_V4}/signup/`,

  // Message
  MESSAGE: `${config.API_URL_V4}/messages/`,

  // Widgets
  INSIGHTS_ANALYTICS_WIDGETS: `${config.API_URL}/widgets/:metric/:search_id/`,
  SYNCHRONOUS_REPORT_WIDGETS: `${config.API_URL}/report-widgets/:metric/:widget_id/`,

  // API Token
  API_TOKEN: `${config.API_URL_NEW}/user/api-token/`,

  // API Docs
  API_DOCS: "https://api.allears.ai/docs",

  // Company info (query-builder-service)
  COMPANY_INFO: "/qb-api/api/v1/company_info",

  // Build sync (query-builder-service)
  BUILD_SYNC: "/qb-api/api/v1/build/sync",
};
